'use strict';

var buildFromIndexMethods = require('../internal/buildFromIndexMethods');

buildFromIndexMethods();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/enumerable/build/buildFromIndexMethodsCall.js
// module id = 25
// module chunks = 0